module.exports = __webpack_public_path__ + "img/Route_1.e992c821.png";